/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum VisibilityOption {
    Required = 192,
    Optional = 193,
    Hidden = 194,
}
